import { useEffect, useRef, useState } from 'react';

//Primereact components
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { Toolbar } from 'primereact/toolbar';
import { LetterShowClick, UniversityLetterValidate } from '../../../../config/Validate';
import { defaultPageRowOptions, defaultRowOptions, SkeletonbodyTemplate, Skeletonitems } from '../../../../appconfig/Settings';
import { getAllDetailsDirect, getSpecificDetailsById, postAllData } from '../../../../service/ProductService';
import { DOWNLOADVERIFICATIONLETTER, LETTERMASTERUNIVERSITYLIST, STOREVERIFICATION, VERIFICATION } from '../../../../config/ApiConstant';
import { AddUniversityLetterListColumns } from '../../../../appconfig/DatatableSetting';
import { commonNameTemplate, dateTemplate } from '../../../../appconfig/DatatableTemplateSetting';
import { VerificationTab } from '../VerificatuionTab';
import { LettersTab } from '../../LettersTab';
import { Dropdown } from 'primereact/dropdown';
import { InputTextarea } from 'primereact/inputtextarea';
import Loader from '../../../../components/Loadeer/Loader';

export const UniversityLetter = () => {
    document.title = 'Verification University  Letter | GSPC';

    //Set Toast/ Filter Properties
    const toast = useRef<any>(null);
    const [globalFieldFilter, setGlobalFieldFilter] = useState<any>(null);
    const [globalFilter, setGlobalFilter] = useState<any>(null);

    //Loading/Page Loading
    const [pageLoad, setPageLoad] = useState<boolean>(true);
    const [errors, setErrors] = useState<any>({});
    const [regNo, setRegNo] = useState<any>(null);
    const [universityData, setUniversityData] = useState<any>({});
    const [addLoader, setAddLoader] = useState<boolean>(false);
    const [universityList, setUniversityList] = useState<any>([]);
    const [showLoading, setShowLoading] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [buttonVisible, setButtonVisible] = useState<boolean>(true);
    const [universityOptions, setUniversityOptions] = useState<any>([]);
    const [selectedUniversity, setSelectedUniversity] = useState<any>(null);
    const [universityAddress, setUniversityAddress] = useState<any>([]);

    // useEffect
    useEffect(() => {
        getUniversityLetter();
        getAllUniversity();
    }, []);

    // Get University
    const getAllUniversity = async () => {
        try {
            const response = await getAllDetailsDirect(LETTERMASTERUNIVERSITYLIST + '?type=all');

            if (response) {
                const DataList: any = response;
                if (DataList.length === 0) {
                    setUniversityOptions([]);
                } else {
                    setUniversityAddress(DataList);

                    let universityData = [];
                    for (let i = 0; i < DataList.length; i++) {
                        const universityObj: any = {};
                        universityObj['name'] = DataList[i].UName;
                        universityObj['code'] = DataList[i].SrNo;
                        universityData.push(universityObj);
                    }
                    setUniversityOptions(universityData);
                }
            } else {
                setUniversityOptions([]);
            }
        } catch (error: any) {
            setUniversityList([]);
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Sorry Could Not Load Data'
            });
        }
    };

    // Global search
    const leftToolbarTemplate = () => {
        return (
            <>
                <span className="search-bar mr-3">
                    <i className="pi pi-search"></i>
                    <InputText type="search" className="search-input" onInput={(e) => setGlobalFilter(e.currentTarget.value)} placeholder="Search..." />
                </span>
            </>
        );
    };

    // Right toolbar
    const rightToolbarTemplate = () => {
        return (
            <>
                <Button icon="pi pi-filter-slash" label="Clear" onClick={() => clearAllFilter()} className="p-button-outlined"></Button>
            </>
        );
    };

    //Clear All Filter
    const clearAllFilter = () => {
        setGlobalFieldFilter(null);
        setGlobalFilter(null);
    };

    // Clear all
    const clearAll = () => {
        setRegNo(null);
        setUniversityData({});
        setSelectedUniversity(null);
        setErrors({});
    };

    // getUniversitLetterList
    const getUniversityLetter = async () => {
        if (!window.cn(regNo)) {
            try {
                const response = await getAllDetailsDirect(VERIFICATION + '?VerificationBy=University' + '&FileNo=' + regNo + '&page=' + 1 + '&per_page=' + 100 + '&search=' + '');
                const { List } = response;

                
                if (!window.cn(response) && Object.keys(response?.Details).length !== 0) {
                    const { StudF, StudM, StudL } = response?.Details;
                    let FromNm = (!window.cn(StudL) ? StudL : '') + ' ' + (!window.cn(StudF) ? StudF : '') + ' ' + (!window.cn(StudM) ? StudM : '');
                    setUniversityData({
                        Name: FromNm,
                        ToAddress: ''
                    });
                    setUniversityList(List);
                    setShowLoading(false);
                    setButtonVisible(false);
                } else {
                    setButtonVisible(true);
                    setShowLoading(false);
                    setUniversityData({ ...universityData });
                }
            } catch (error: any) {
                if (error.response) {
                    //Spinner False and Set Toast
                    setShowLoading(false);
                    toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Could Not Load Data' });
                }
            }
        } else {
            try {
                setPageLoad(false);
                const response = await getAllDetailsDirect(VERIFICATION + '?VerificationBy=University' + '&per_page=' + 100 + '&page=' + 1 + '&search=' + '');

                if (response) {
                    const { List } = response;
                    setUniversityList(List);
                    setPageLoad(true);
                }
            } catch (error: any) {
                if (error.response) {
                    //Spinner False and Set Toast
                    setPageLoad(true);

                    toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Could Not Load Data' });
                }
            }
        }
    };

    //\ onShowClick get User Deatsils
    const getUserDetails = async () => {
        try {
            const { errors, isError } = LetterShowClick(regNo);
            setErrors(errors);

            //Check Error if no errors then call API
            if (!isError) {
                setShowLoading(true);
                // setPageLoad(false);

                getUniversityLetter();
            }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast
                setShowLoading(false);
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Could Not Load Data' });
            }
        }
    };
    //onchange event
    const onUniversitySelect = (e: any) => {
        setSelectedUniversity(e);
        getUniversityAddress(e);
    };

    //getUniversirtAddress
    const getUniversityAddress = (name: any) => {
        universityAddress.map((item: any) => {
            if (item?.SrNo === name?.code) {
                setUniversityData({ ...universityData, ToAddress: item?.Uadd ? item.Uadd : '' });
            }
        });
    };

    // Add inward data
    const adduniversityData = async () => {
        try {
            const { errors, isError } = UniversityLetterValidate(selectedUniversity, regNo);
            setErrors(errors);
            //Check Error if no errors then call API
            if (!isError) {
                setAddLoader(true);

                let requestData = { ...universityData };
                requestData['FileNo'] = Number(regNo);
                requestData['IdUniBordCol'] = selectedUniversity?.code;
                requestData['UniBordCol'] = selectedUniversity?.name;
                requestData['VerificationBy'] = 'University';

                const response = await postAllData(STOREVERIFICATION, requestData);
                if (response) {
                    setAddLoader(false);
                    toast.current?.show({ severity: 'success', summary: 'Message', detail: response?.data });
                    setUniversityData({});
                    clearAll();
                    getUniversityLetter();
                }
            }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast
                setAddLoader(false);
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Something Went Wrong' });
            }
        }
    };

    // Template for actions
    const actionsTemplate = (rowData: any) => {
        return (
            <>
                <div className="actions action-btn">
                    <Button icon="pi pi-download" onClick={() => downloadUniversityLetter(rowData?.SrNo)} tooltip="Download" tooltipOptions={{ position: 'top' }} />
                </div>
            </>
        );
    };

    // Download bank entry
    const downloadUniversityLetter = async (id: any) => {
        try {
            setLoading(true);

            const response = await getSpecificDetailsById(DOWNLOADVERIFICATIONLETTER, id);

            //Check response and download
            if (response) {
                //PDF Download
                const { file_url } = response;
                setLoading(false);

                //PDF Download
                const fileName = `verification-university-letter-${new Date().getTime()}.pdf`;
                const link = document.createElement('a');
                link.href = file_url;
                link.target = '_blank';
                link.download = fileName;
                document.body.appendChild(link);
                link.click();
            }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast
                setLoading(false);
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Something Went Wrong' });
            }
        }
    };

    return (
        <>
            <LettersTab mainTabLabel="Verification Letters" />
            <VerificationTab initialTabLabel="University Verification Letters" />

            <Toast ref={toast} />
            <div className="grid crud-demo mt-2">
                <div className="col-12">
                    <div className="card">
                        <div className="p-fluid formgrid grid align-items-center">
                            <div className="field col-12 md:col-4">
                                <label htmlFor="regNo">
                                    File No <span style={{ color: 'red' }}>*</span>
                                </label>
                                <InputText value={!window.cn(regNo) ? regNo : ''} name="regNo" keyfilter="num" autoComplete="off" placeholder="Enter File No." onChange={(e) => setRegNo(e.target.value)} className={errors['regNo'] && 'p-invalid'} />
                                <small className="p-invalid-txt">{errors['regNo']}</small>
                            </div>
                            <div className="field col-12 md:col-1 mt-4">
                                <Button label="Search" className="p-button-primary" onClick={() => getUserDetails()} loading={showLoading} />
                            </div>
                        </div>
                        <hr />
                        <div className="p-fluid formgrid grid">
                            <div className="field col-12 md:col-4">
                                <label htmlFor="Name">
                                    Name <span style={{ color: 'red' }}>*</span>
                                </label>
                                <InputText value={!window.cn(universityData?.Name) ? universityData?.Name : ''} name="Name" disabled={true} />
                            </div>
                            <div className="field col-12 md:col-4">
                                <label htmlFor="RollNo">
                                    University <span style={{ color: 'red' }}>*</span>
                                </label>
                                <Dropdown
                                    value={selectedUniversity}
                                    name="university"
                                    options={universityOptions}
                                    filter
                                    optionLabel="name"
                                    placeholder="Select University"
                                    onChange={(e) => onUniversitySelect(e.value)}
                                    className={errors['university'] && 'p-invalid'}
                                />
                                <small className="p-invalid-txt">{errors['university']}</small>
                            </div>
                            <div className="field col-12 md:col-4">
                                <label htmlFor="ToAddress">Address</label>
                                <InputTextarea value={!window.cn(universityData?.ToAddress) ? universityData?.ToAddress : ''} name="ToAddress" disabled={true} rows={4} />
                            </div>
                        </div>
                        <div className="formgrid grid">
                            <div className="field col-12 md:col-12">
                                <div style={{ display: 'flex', float: 'right', gap: 4 }}>
                                    <Button label="Clear" icon="pi pi-times" className="p-button-secondary mr-2" onClick={() => clearAll()} />
                                    <Button label="Save" icon="pi pi-check" onClick={() => adduniversityData()} loading={addLoader} disabled={buttonVisible} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="card">
                        <Toolbar left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>
                        {/* Datatable */}
                        {pageLoad ? (
                            <>
                                <DataTable
                                    value={universityList}
                                    showGridlines
                                    stripedRows
                                    globalFilter={globalFilter}
                                    filters={globalFieldFilter}
                                    onFilter={(e) => setGlobalFieldFilter(e.filters)}
                                    rows={defaultRowOptions}
                                    paginator={universityList.length >= 10 && true}
                                    rowsPerPageOptions={defaultPageRowOptions}
                                    className="datatable-responsive p-datatable-sm"
                                    emptyMessage="No Data Found"
                                    removableSort
                                >
                                    {AddUniversityLetterListColumns.map((col, i) => {
                                        if (col.field === 'action') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={actionsTemplate} />;
                                        } else if (col.field === 'created_at') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={dateTemplate} style={{ minWidth: '8rem' }} />;
                                        } else if (col.field === 'UniBordCol') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={commonNameTemplate} />;
                                        } else if (col.field === 'ToAddress') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={commonNameTemplate} />;
                                        } else if (col.field === 'FileNo') {
                                            return <Column key={col.field} field={col.field} header={col.header} style={{ minWidth: '8rem' }} />;
                                        } else {
                                            return <Column key={col.field} field={col.field} header={col.header} sortable filter filterPlaceholder={'Search by ' + col.header} />;
                                        }
                                    })}
                                </DataTable>
                            </>
                        ) : (
                            <>
                                {/* Skeleton Data table */}
                                <DataTable value={Skeletonitems}>
                                    {AddUniversityLetterListColumns.map((col, i) => (
                                        <Column key={col.field} field={col.field} header={col.header} body={SkeletonbodyTemplate} />
                                    ))}
                                </DataTable>
                            </>
                        )}
                    </div>
                </div>
            </div>

            {loading === true ? <Loader /> : ''}
        </>
    );
};
